<script setup>
const props = defineProps({
  theme: {
    type: String,
    default: null,
  },
  size: {
    type: String,
    default: 'medium',
  },
  isPill: {
    type: Boolean,
    default: false,
  },
  isFullwidth: {
    type: Boolean,
    default: false,
  },
  isHoverable: {
    type: Boolean,
    default: false,
  },
})

const sizes = {
  smallest: '32px',
  smaller: '40px',
  small: '48px',
  medium: '80px',
  large: '96px',
  largest: '120px',
}
</script>

<template>
  <div
    class="base-bubble"
    :class="[`base-bubble--${props.theme}`, { 'base-bubble--pill': props.isPill, 'base-bubble--fullwidth': props.isFullwidth, 'base-bubble--hoverable': props.isHoverable }]"
  >
    <slot />
  </div>
</template>

<style lang="scss">
.base-bubble {
  display: flex;

  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  border-radius: $border-radius-circular;
  width: v-bind('sizes[props.size]');
  height: v-bind('sizes[props.size]');

  &--pill {
    border-radius: $border-radius-pill;
    padding: $spacer-half $spacer;
    width: fit-content;
  }

  &--fullwidth {
    width: 100%;
  }

  &--hoverable {
    &:hover {
      @media (hover: hover) {
        background-color: $color-neutral-ultralight;
        cursor: pointer;
      }
    }
  }

  &--white {
    background-color: $color-neutral-white;
  }

  &--secondary-light {
    background-color: $color-secondary-light;
  }

  &--info {
    background-color: $color-feedback-info-light;
  }

  &--success {
    background-color: $color-feedback-success-light;
  }

  &--tertiary-light {
    background-color: $color-tertiary-alt-light;
  }

  &--primary-dark {
    background-color: $color-primary-dark;
  }
}
</style>
